import { toaster, Message, } from 'rsuite';
import { getToken, Check_login_ticket } from './helper';



export var MyAlbums = []
export var Curation = []


// Helper for API calls
const apiCall = async (url, method = 'GET', body = null, hideToaster = false) => {
    let token = getToken();
    const headers = {
        'Content-Type': 'application/json',
        "Semabench-Token": token,
        "Cache-Control": "max-age=0"
    };

    if (!hideToaster) toaster.clear();

    try {
        const response = await fetch(url, {
            method,
            headers,
            body: body ? JSON.stringify(body) : null,
        });

        if (response.status === 401) {
            await Check_login_ticket();
            return null;
        }

        const responseBody = await response.text();

        // Only parse JSON if the response is not empty
        return responseBody ? JSON.parse(responseBody) : null;
    } catch (error) {
        console.error('API Error:', error);
        if (!hideToaster) {
            toaster.push(<Message type="error" showIcon closable>{error.message || "An error occurred."}</Message>);
        }
        return undefined;
    }
};


// API to get album Nodes
export const getAlbumNodes = async (uaid) => {
    if (!uaid) return undefined;
    const result = await apiCall(`../api/v1/albumnodes?uaid=${uaid}`);
    if (uaid === 1) {
        Curation = result;
    }
    return result;
};

// remove the item from the album
export async function removeFromAlbum(uaid, nodes, hide) {
    if (!uaid || !nodes) return;

    if (uaid !== "1" && !hide) {
        toaster.push(<Message type="info" showIcon closable>Removing Items...</Message>);
    }

    const url = "../api/v1/albumnodes";
    const result = { uaid: parseInt(uaid), nodes };
    await apiCall(url, "DELETE", result);

    if (uaid !== "1" && !hide) {
        toaster.push(<Message type="success" showIcon closable>Items Removed</Message>, { duration: 3000 });
    }
}

export async function updateAlbum(uaid, album) {
    if (!uaid || !album) return;

    const url = `../api/v1/album?uaid=${uaid}`;
    const success = await apiCall(url, "POST", album);

    if (success) {
        toaster.push(<Message type="success" showIcon closable>{`Album ${album.name} Updated.`}</Message>, { duration: 4000 });
    }
}


// Calls the api to get the UAIDs that the node belongs in
export async function getAlbumByNode(node) {
    if (!node) return undefined;

    const url = `../api/v1/album/node?node=${node}`;
    return await apiCall(url);
}

// Method to call the back and loads the albums.
export async function getMyAlbums() {
    const url = "../api/v1/user/myalbums";
    const result = await apiCall(url);

    if (!result || !Array.isArray(result)) return [];

    MyAlbums = result.filter(({ uaid, parameters, continuity }) =>
        uaid !== 1 && uaid !== 2 && parameters === null && (!continuity || continuity === "")
    );
    return MyAlbums;
}
